import { createUseStyles } from 'react-jss'
import { commonStyles } from '../../shared/common.styles'

const useStyles = createUseStyles(theme => ({
  ...commonStyles(theme),
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 10
  },

  buttonWrapper: {
    width: '45%',
    maxWidth: 756,
    [theme.media.tablet]: {
      width: '100%',
      maxWidth: 1023
    },
    [theme.media.mobile]: {
      width: '100%'
    },
    [theme.media.smallMobile]: {
      width: '100%'
    }
  },

  selectPlanButton: {
    zIndex: theme.zIndexCardBadge,
    position: 'relative',
    margin: [30, 0, 20, 0],
    lineHeight: '20px'
  },

  closeButton: {
    margin: [0, 0, 40, 0],

    [theme.media.smallMobile]: {
      margin: [0, 0, 20, 0]
    }
  },

  disabledButton: {
    pointerEvents: 'none',
    opacity: 0.4
  }
}))

export default useStyles
